import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";
import { GROUP_PROFILE_INFO_UPDATED } from "../../Helpers/Chat/Constant";
import { StateToObj } from "./reduxHelper";

const initialState = {}

const updateGroupDetails = (currentData, groupData = []) => {
    let index = groupData.findIndex((obj) => currentData.groupJid.indexOf(obj.groupId) > -1);
    if (index > -1) {
      groupData[index].groupName = currentData.groupName || currentData.groupProfile?.nickName || groupData[index].groupName;
      groupData[index].isAdminBlocked = currentData.isAdminBlocked;
      if (currentData.msgType === GROUP_PROFILE_INFO_UPDATED) {
        // Should not update the image from 'groupData[index].groupImage', because If user removed
        // the image of group, then the existing image will set from 'groupData'.
        // So when msgType is 'profileUpdated', use below condition to set updated/removed image
        groupData[index].groupImage = currentData.groupImage || currentData.groupProfile?.image || '';
        groupData[index].thumbImage = currentData.thumbImage || currentData.groupProfile?.thumbImage || "";
      }
    }
    return groupData;
  };

const groupsData = createSlice({
    name:'groupsData',
    initialState,
    reducers:{
        addGroupsData: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        },
        updateGroupsData: (_state,payload) => {
                return{
                    ..._state,
                    "id": uuidv4(),
                    "data": updateGroupDetails(payload.payload, StateToObj(_state)?.data)
                }
        }
    }
});

export default groupsData.reducer
export const addGroupsData = groupsData.actions.addGroupsData
export const updateGroupsData = groupsData.actions.updateGroupsData